document.addEventListener('DOMContentLoaded', function () {
  const fileFieldContainer = document.querySelectorAll('.file-field');

  if (fileFieldContainer.length) {
    for (const container of fileFieldContainer) {
      const fileInput = container.querySelector('input[type="file"]');
      const labelContainer = container.querySelector('label');

      addFileFieldChangeEvent(fileInput, container);
      addFileFieldDragAndDropEvent(fileInput, labelContainer);
    }
  }
});

function addFileFieldChangeEvent(input, container) {
  const title = container.querySelector('.file-field-title');
  const subtitle = container.querySelector('.file-field-subtitle');
  const label = container.querySelector('label');
  const image = container.querySelector('.file-field-image');

  if (title && !!title.querySelector('a')) {
    const fileName = title.querySelector('span.line-clamp-2');
    fileName.innerText = handleFileNameLength(fileName.innerText);
  }

  input.addEventListener('change', () => {
    const file = input.files[0];

    if (!file) {
      return;
    }

    if (title) {
      const fileName = title.querySelector('span.line-clamp-2');
      fileName.innerText = handleFileNameLength(file.name);
      const seeFileLink = title.querySelector('a');
      title.removeChild(seeFileLink);
    }

    if (subtitle) {
      subtitle.innerText = '';
    }

    if (label) {
      label.classList.remove('border-danger', 'border-light-primary', 'border-pending', 'border-success');
      label.classList.add('border-primary');
    }

    if (image) {
      image.src = image.dataset.defaultImage;
    }
  });
}

function addFileFieldDragAndDropEvent(input, labelContainer) {
  labelContainer.addEventListener('dragenter', (ev) => ev.preventDefault());
  labelContainer.addEventListener('dragover', (ev) => ev.preventDefault());
  labelContainer.addEventListener('drop', (ev) => {
    input.files = ev.dataTransfer.files;

    ev.preventDefault();
  })
}

function handleFileNameLength(name) {
  return name.length > 30 ? `${name.substring(0, 15)}...${name.substring(name.length - 15)}` : name;
}

window.addFileFieldChangeEvent = addFileFieldChangeEvent;
window.addFileFieldDragAndDropEvent = addFileFieldDragAndDropEvent;
